// CardContent.tsx

import { Box } from '@mui/material'
import React, { PropsWithChildren } from 'react'

export default function CardContent({ children }: PropsWithChildren<Record<string, unknown>>) {
  return <Box sx={{ height: '100%', width: '100%' }}>{children}</Box>
}
